import { ID_INNENSTADT_KINOS } from '@cineamo/api/constants/cinema-ids';

import { CleverReachList, CleverReachSecrets } from './cleverreach.types';

/**
 * Get CleverReach list ID based on cinema configuration
 * Different cinemas might use different newsletter lists
 */
export function getCleverReachListId(cinemaId: number, type: CleverReachList): string | null {
    // Map cinema IDs to their respective CleverReach list IDs
    switch (cinemaId) {
        case ID_INNENSTADT_KINOS: // Innstadtkinos
            switch (type) {
                case CleverReachList.general:
                    return '523204'; // General newsletter list ID for Innstadtkinos
                case CleverReachList.kids_teens:
                    return '981750'; // Kids & Teens newsletter list ID for Innstadtkinos
            }
    }

    return null;
}

/**
 * Get CleverReach secrets based on cinema configuration
 * Different cinemas might use different CleverReach accounts
 */
export function getCleverReachSecrets(cinemaId?: number): CleverReachSecrets | null {
    // Map cinema IDs to their respective CleverReach credentials
    switch (cinemaId) {
        case ID_INNENSTADT_KINOS: // Innstadtkinos
            return {
                clientId: process.env.CLEVERREACH_CLIENT_ID_INNENSTADTKINOS,
                clientSecret: process.env.CLEVERREACH_CLIENT_SECRET_INNENSTADTKINOS,
                tokenUrl: process.env.CLEVERREACH_TOKEN_URL_INNENSTADTKINOS
            };
    }

    return null;
}

/**
 * Validate email address format.
 *
 * Rejects `*` outright — it's the sentinel character of our server-side
 * email-masking output (`a*****@cineamo.com`). Without this guard a masked
 * display value can pass the regex and end up being stored as a subscriber's
 * address. Gmail-style `+suffix` aliasing remains supported.
 */
export function isValidEmail(email: string): boolean {
    if (email.includes('*')) return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}
